import styled from "styled-components";

interface RootProps {
    isVisible: boolean;
}

export const Root = styled.div<RootProps>`
    padding: 10px 20px;
    display: ${({ isVisible }) => (isVisible ? "block" : "none")};

    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        padding: 10px 30px;
    }
`;

export const Container = styled.div`
    display: flex;
    align-items: center;
`;

export const Caption = styled.div`
    font-weight: 400;
    margin-bottom: 8px;
    font-size: 14px;
    line-height: 24px;

    ${({ theme }) => theme.breakpoints.md.mediaquery} {
        font-size: 16px;
    }
`;
